import { Modal } from '@mantine/core';
import { ProductQRCode } from './ProductQRCode';

export interface ProductQRCodeDialogProps {
  opened: boolean;
  onClose: () => void;
  url: string;
  accentColor: string;
  logoImage?: string;
  showStyleToggle?: boolean;
  showArInfo?: boolean;
  zIndex?: number;
  portalTarget?: string | HTMLElement;
}

export function ProductQRCodeDialog({
  opened,
  onClose,
  url,
  accentColor,
  logoImage,
  showStyleToggle = false,
  showArInfo = false,
  zIndex,
  portalTarget,
}: ProductQRCodeDialogProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<div style={{ display: 'none' }} />}
      centered
      size="md"
      radius="lg"
      padding="md"
      zIndex={zIndex}
      portalProps={portalTarget ? { target: portalTarget } : undefined}
      overlayProps={{ blur: 3 }}
      styles={{
        content: { boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)' },
        header: { padding: 0, marginBottom: 0, marginRight: 12 },
        close: { marginRight: 10 },
        body: { paddingTop: 5 },
      }}
    >
      <ProductQRCode
        value={url}
        accentColor={accentColor}
        logoImage={logoImage}
        showStyleToggle={showStyleToggle}
        showArInfo={showArInfo}
      />
    </Modal>
  );
}
